import {cx} from '@emotion/css';
import React, {ReactElement, useState} from 'react';
import Field from '@fo/designSystem/Fields/Field/Field';
import {Field as FieldType} from '@fo/designSystem/Fields/types';

import styles from './Checkbox.styles';

interface Props extends Omit<FieldType, 'value' | 'label'> {
  checked: boolean;
  label: string | JSX.Element;
}

function Checkbox({
  assistiveMessage = '',
  errorMessage = '',
  label,
  checked,
  isDisabled = false,
  onChange,
  onBlur = () => {
    /* noop */
  },
  name,
  className,
  testId,
}: Props): ReactElement {
  const [hasFocus, setHasFocus] = useState(false);

  return (
    <Field
      name={name}
      assistiveMessage={assistiveMessage}
      errorMessage={errorMessage}
      isDisabled={isDisabled}
      className={className}
    >
      <div className={cx(styles.checkbox)}>
        <input
          name={name}
          type="checkbox"
          onChange={onChange}
          onBlur={(e) => {
            setHasFocus(false);
            onBlur(e);
          }}
          onFocus={() => {
            setHasFocus(true);
          }}
          id={name}
          checked={checked}
          disabled={isDisabled}
          className={cx(styles.input)}
          data-disabled={isDisabled}
          data-testid={testId}
        />
        <label htmlFor={name} className={cx(styles.label(checked, isDisabled, hasFocus))}>
          {label}
        </label>
      </div>
    </Field>
  );
}

export default Checkbox;
